import { RespiratoryConstant } from './respiratory.constant'
import { IRespiratoryAction, IRespiratoryState } from './respiratory.types'

export const respiratoryStatePrRespAssess = {
  respExam: [],
}

export const respiratoryStatePrNabc = {
  cvBreathSoundsL: null,
  cvBreathSoundsR: null,
  cvBreathComments: '',
  cvRespEffort: null,
  cvO2: null,
  rfio2: null,
  fio2AirTemp: null,
  fio2Humidity: null,
  cvVia: null,
  respBy: null,
  respOutcome: null,
  respComments: '',
  fio2AirTempUnit: 'c',
}

export const respiratoryState: IRespiratoryState = {
  ...respiratoryStatePrRespAssess,
  ...respiratoryStatePrNabc,
}

export function RespiratoryReducer(
  state: IRespiratoryState = respiratoryState,
  action: IRespiratoryAction
): IRespiratoryState {
  switch (action.type) {
    case RespiratoryConstant.NOT_IMPLEMENTED:
      alert('Not implemented')
      return state
    case RespiratoryConstant.SET_BREATHSOUNDS_LEFT:
      return { ...state, cvBreathSoundsL: action.cvBreathSoundsL }
    case RespiratoryConstant.SET_BREATHSOUNDS_RIGHT:
      return { ...state, cvBreathSoundsR: action.cvBreathSoundsR }
    case RespiratoryConstant.SET_BREATHSOUNDS_COMMENT:
      return { ...state, cvBreathComments: action.cvBreathComments }
    case RespiratoryConstant.SET_RESPIRATORY_EFFORT:
      return { ...state, cvRespEffort: action.cvRespEffort }
    case RespiratoryConstant.SET_O2:
      return { ...state, cvO2: action.cvO2 }
    case RespiratoryConstant.SET_RFIO2:
      return { ...state, rfio2: action.rfio2 }
    case RespiratoryConstant.SET_FIO2AirTemp:
      return { ...state, fio2AirTemp: action.fio2AirTemp }
    case RespiratoryConstant.SET_FIO2AirTemp_UNIT:
      return { ...state, fio2AirTempUnit: action.fio2AirTempUnit }
    case RespiratoryConstant.SET_FIO2Humidity:
      return { ...state, fio2Humidity: action.fio2Humidity }
    case RespiratoryConstant.SET_VIA:
      return { ...state, cvVia: action.cvVia }
    case RespiratoryConstant.SET_PERFORMEDBY:
      return { ...state, respBy: action.respBy }
    case RespiratoryConstant.SET_OUTCOME:
      return { ...state, respOutcome: action.respOutcome }
    case RespiratoryConstant.SET_RESP_EXAM:
      return { ...state, respExam: action.respExam }
    case RespiratoryConstant.SET_RESP_COMMENT:
      return { ...state, respComments: action.respComments }
    case RespiratoryConstant.SET_RESPIRATORY:
      return { ...state, ...action.respiratory }
    case RespiratoryConstant.RESET_STATE:
      return {
        ...respiratoryState,
      }
    default:
      return state
  }
}
